import { portalRoutes } from "@/router/routes/portalRoutes";

export interface Redirect {
  from: string;
  to: string;
}

// List of redirects, get converted to working redirects in ./Routing.tsx
const redirects: Redirect[] = [
  {
    from: "/dr/user",
    to: portalRoutes.cockpit.base,
  },
  {
    from: "/dr/user/payment/card",
    to: portalRoutes.documents.payments,
  },
  {
    from: "/dr/user/dashboard",
    to: portalRoutes.cockpit.base,
  },
  {
    from: "/dr/user/check-id",
    to: portalRoutes.cockpit.base,
  },
];

export default redirects;
